import { render, staticRenderFns } from "./FoundContracts.vue?vue&type=template&id=6455c01c&scoped=true"
import script from "./FoundContracts.vue?vue&type=script&lang=js"
export * from "./FoundContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6455c01c",
  null
  
)

export default component.exports